import { cn } from '@/lib/utils';

export interface SkeletonBarProps {
  readonly className?: string;
}

export function SkeletonBar({ className }: SkeletonBarProps) {
  return (
    <div
      className={cn('bg-sand-200 dark:bg-sand-700 animate-pulse rounded', className)}
      aria-hidden="true"
    />
  );
}
